import AiDesignVsChatbots from './content/AiDesignVsChatbots';
import FindingContractors from './content/FindingContractors';

// Central registry of blog posts. To add a post, write a body component in
// ./content and add an entry here. Order is newest-first (index page renders
// them in this order). `body` is a React component rendering the article body;
// `title`/`description` drive the page <title> and meta description for SEO.
export const POSTS = [
  {
    slug: 'ai-design-vs-chatbots',
    title:
      'How Plum makes AI design better than ChatGPT, Gemini, or Claude for home design',
    description:
      'General chatbots give quick ideas. Plum adds structure, memory, designs grounded in your real space, and contractor-ready deliverables purpose-built for renovations.',
    date: '2026-06-09',
    author: 'The Plum Team',
    readMinutes: 5,
    body: AiDesignVsChatbots,
  },
  {
    slug: 'finding-contractors-problem',
    title:
      'The problems of finding contractors historically — and how Plum addresses them',
    description:
      'Spam calls, non-comparable quotes, and budget-busting change orders have long made hiring a contractor painful. Here is how Plum tackles each problem.',
    date: '2026-06-09',
    author: 'The Plum Team',
    readMinutes: 6,
    body: FindingContractors,
  },
];

// Look up a single post by its URL slug. Returns undefined when not found so
// the post page can render a friendly "not found" state.
export function getPostBySlug(slug) {
  return POSTS.find((post) => post.slug === slug);
}
